<script>
import PersonNameConverter from "../../Services/PersonNameConverter";
import {mapActions, mapState} from "vuex";

export default {
  name: "MeetingScholarshipStatementsTable",

  props: {
    itemsPerPage: {
      type: Number,
      default: 8,
    },


    items: {
      type: Array,
      default: [],
    },
  },

  data() {
    return {
      page: 1,

      headers: [
        {
          text: 'Место',
          value: 'Number',
          groupable: false,
          sortable: false,
          width: '6%',
          align: "center",
          cellClass: "text-body-1",
        },
        {
          text: 'Участник',
          value: 'participant',
          groupable: false,
          sortable: false,
          width: '25%',
        },
        {
          text: 'Тип деятельности',
          value: 'achievement_type_name',
          groupable: false,
          sortable: false,
          width: '35%',
          divider: true,
        },
        {
          text: 'Сумма по деятельности',
          value: 'sum_score_selected_activity',
          groupable: false,
          sortable: false,
          width: '13%',
          align: 'center',
        },
        {
          text: 'Общая сумма баллов',
          value: 'sum_score',
          groupable: false,
          sortable: false,
          width: '13%',
          divider: true,
          align: 'center',
        },
        {
          text: 'Посмотреть',
          value: 'views',
          groupable: false,
          sortable: false,
          width: '8%',
          align: 'center',
        },
      ],
    }
  },

  computed: {
    PersonNameConverter() {
      return PersonNameConverter
    },

    numberOfPages () {
      return Math.ceil(this.items.length / this.itemsPerPage)
    },

    ...mapState({
      meeting: state => state.scholarship_meeting.meeting,
    }),


  },

  methods: {

    ...mapActions({
      getStatement: "scholarship_competition/getStatement",
    }),

    showStudentStatement(id) {
      this.getStatement(id);
    },

  },
}
</script>

<template>
  <v-data-table
    :headers="headers"
    :items="items"
    hide-default-footer
    class="text-body-1"
    item-key="id"
    :page.sync="page"
    :items-per-page="itemsPerPage"
  >
    <template #loading>
      Идет загрузка...
    </template>

    <template #no-data>
      Отсутствуют заявления
    </template>

    <template #item.Number="{item, index}">
      {{items.indexOf(item) + 1}}
    </template>

    <template #item.views="{item, index}">
      <v-btn
        icon
        small
        :disabled="!meeting.access_current_meeting"
        @click="showStudentStatement(item.id)"
      >
        <v-icon small>
          fa-eye
        </v-icon>
      </v-btn>
    </template>

    <template #item.sum_score_selected_activity="{item, index}">
      <v-chip small>
        <v-icon small left>
          fa-certificate
        </v-icon>
        {{item.sum_score_selected_activity}}
      </v-chip>
    </template>

    <template #item.sum_score="{item, index}">
      <v-chip small>
        <v-icon small left>
          fa-trophy
        </v-icon>
        {{item.sum_score}}
      </v-chip>
    </template>

    <template #item.participant="{item, index}">
      <v-list-item class="px-0">
        <v-list-item-content>
          <v-list-item-title>
            {{PersonNameConverter.shortName(item.person_full_name)}}
          </v-list-item-title>
          <v-list-item-subtitle>
            Группа {{item.group_name}}
          </v-list-item-subtitle>
          <v-list-item-subtitle v-show="item.is_comment_present">
            <span class="error--text">Есть активные замечания</span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>

    <template #footer>
      <v-divider/>
      <v-row
        class="pb-2 mt-2"
        align="center"
        justify="center">
        <v-col cols="12" class="text-center">
          <v-pagination
            circle
            color="teal darken-3"
            v-model="page"
            :length="numberOfPages"
            :total-visible="5">
          </v-pagination>
        </v-col>
      </v-row>
    </template>

  </v-data-table>
</template>

<style scoped>
</style>